import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';
import { ApiResponse, ApiError } from '../types/api';

// Define the AssetType interface directly to avoid import issues
interface AssetType {
  value: string;
  label: string;
}

/**
 * React-Query hook to retrieve the list of available asset types from the backend.
 */
export const useAssetTypes = () => {
  const { data: assetTypes, isLoading, error } = useQuery({
    queryKey: ['assetTypes'],
    queryFn: () => api.request<ApiResponse<AssetType[]>>('/api/asset_types'),
    refetchOnWindowFocus: false,
  }) as { data: ApiResponse<AssetType[]>; isLoading: boolean; error: ApiError };

  return { assetTypes, isLoading, error };
};
